import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilterOutline = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.27351 14.2635L8.86951 12.5444V6.72814C8.86951 6.35581 9.01651 5.99802 9.28051 5.72896L13.4475 1.45442H1.50001L6.86401 6.95649C7.12651 7.22555 7.27351 7.58334 7.27351 7.95567V14.2635ZM10.3694 6.72814V12.5444C10.3694 12.9036 10.2329 13.2498 9.98536 13.5174L8.07136 15.5768C7.58386 16.1019 6.74986 16.1441 6.20986 15.6714C5.93086 15.4299 5.77336 15.0838 5.77336 14.7202V7.95567L0.409356 2.4536C-0.159144 1.87038 -0.132144 0.949736 0.469356 0.398511C0.746856 0.142533 1.11736 0 1.49986 0H13.4474C14.2754 0 14.9474 0.65158 14.9474 1.45442C14.9474 1.82675 14.8004 2.18454 14.5364 2.4536L10.3694 6.72814Z"
	})]
});
const ForwardRef = forwardRef(SvgFilterOutline);
export { ForwardRef as ReactComponent };
